import { render } from "./Datatable.vue?vue&type=template&id=c2944af4&lang=pug"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=c2944af4&lang=scss"
const cssModules = {}
import style1 from "./Datatable.vue?vue&type=style&index=1&id=c2944af4&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__